/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import { Radio, withStyles } from '@material-ui/core';

const styles = (theme) => ({
    giftMessageRB: {
        color: theme.palette.unCheckRadioBtn,
        '&$giftMsgRBChecked': {
            color: theme.palette.checkRadioBtn,
        },
    },
    giftMsgRBChecked: {},
});

const RadioButton = ({
    id, checked, name, value, onChange, classes,
}) => (
    <Radio
        id={id}
        checked={checked}
        name={name}
        value={value}
        onChange={onChange}
        color="default"
        classes={{
            root: classes.giftMessageRB,
            checked: classes.giftMsgRBChecked,
        }}
    />
);

RadioButton.propTypes = {
    id: PropTypes.string,
    checked: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
};

RadioButton.defaultProps = {
    id: null,
};

export default withStyles(styles)(RadioButton);
